import { defineNuxtRouteMiddleware, navigateTo } from '#imports'

import { CUSTOMER_CARE } from '~/scopes/customer-care/route-names'
import { ROUTE_NAMES } from '~/scopes/dashboard/constants'
import { HELP_CENTER } from '~/scopes/help-center/route-names'
import { dewebviewifyRouteName } from '~/scopes/webviews/utils'

const { DASHBOARD } = ROUTE_NAMES

const ORDERS_TARGET_NAMES = new Set<string>([
  DASHBOARD.MY_ORDERS.SELF,
  DASHBOARD.MY_ORDERS.SELECT_YOUR_ORDERLINE,
  CUSTOMER_CARE.RESOLUTION.SELF,
  CUSTOMER_CARE.RESOLUTION.RESOLUTION_CONTACT_CONFIRMATION,
  CUSTOMER_CARE.RESOLUTION.RESOLUTION_RETURN_CONFIRMATION,
])

function resolveTargetName(name: string): string {
  if (ORDERS_TARGET_NAMES.has(name)) return DASHBOARD.MY_ORDERS.SELF

  return HELP_CENTER.HOME
}

export default defineNuxtRouteMiddleware((to, from) => {
  const ticketId = to.query.intercom_ticket_id

  if (!ticketId) return
  // If the page is the same and only the query param changed we don't redirect
  if (from.name && from.name === to.name) return

  const currentName = dewebviewifyRouteName(String(to.name ?? ''))
  const target = resolveTargetName(currentName)

  if (currentName === target) return

  // eslint-disable-next-line consistent-return
  return navigateTo({
    name: target,
    replace: true,
    params: { locale: to.params.locale },
    query: { intercom_ticket_id: String(ticketId) },
  })
})
